"use client";
import { ReactComponent as SolteroActiveIcon } from "../public/svg/singleActive.svg";
import { ReactComponent as SolteroInactiveIcon } from "../public/svg/singleInactive.svg";
import { ReactComponent as CasadoActivoIcon } from "../public/svg/marriedActive.svg";
import { ReactComponent as CasadoInactivoIcon } from "../public/svg/marriedInactive.svg";
import { ReactComponent as UnionLibreActiveIcon } from "../public/svg/freeUnionActive.svg";
import { ReactComponent as UnionLibreInactiveIcon } from "../public/svg/freeUnionInactive.svg";
import { ReactComponent as DivorciadoActiveIcon } from "../public/svg/divorciedActive.svg";
import { ReactComponent as DivorciadoInactiveIcon } from "../public/svg/divorciedinactive.svg";

import { ReactComponent as HombreActiveIcon } from "../public/svg/GenderMaleActive.svg";
import { ReactComponent as HombreInactiveIcon } from "../public/svg/GenderMaleInactive.svg";
import { ReactComponent as FemininoActiveIcon } from "../public/svg/GenderFemaleActive.svg";
import { ReactComponent as FemininoInactiveIcon } from "../public/svg/GenderFemaleInactive.svg";
import { ReactComponent as OtrosActiveIcon } from "../public/svg/otherActive.svg";
import { ReactComponent as OtrosInactiveIcon } from "../public/svg/otherInactive.svg";

import { ReactComponent as PrimariaActiveIcon } from "../public/svg/BackpackActive.svg";
import { ReactComponent as PrimariaInacticeIcon } from "../public/svg/BackpackInactive.svg";
import { ReactComponent as BachilleratoActiveIcon } from "../public/svg/CertificateActive.svg";
import { ReactComponent as BachilleratoInactiveIcon } from "../public/svg/CertificateInactive.svg";
import { ReactComponent as TecnicoActiveIcon } from "../public/svg/HardHatActive.svg";
import { ReactComponent as TecnicoInactiveIcon } from "../public/svg/HardHatInactive.svg";
import { ReactComponent as TecnologoActiveIcon } from "../public/svg/HeadCircuitActive.svg";
import { ReactComponent as TecnologoInactiveIcon } from "../public/svg/HeadCircuitInactive.svg";
import { ReactComponent as UniversitarioActiveIcon } from "../public/svg/GraduationCapActive.svg";
import { ReactComponent as UniversitarioInactiveIcon } from "../public/svg/GraduationCapInactive.svg";
import { ReactComponent as PostgradoActiveIcon } from "../public/svg/postGraduatedActive.svg";
import { ReactComponent as PostgradoInactiveIcon } from "../public/svg/postGraduatedInactive.svg";

import { ReactComponent as EmpleadoActiveIcon } from "../public/svg/BriefcaseActive.svg";
import { ReactComponent as EmpleadoInactiveIcon } from "../public/svg/BriefcaseInactive.svg";
import { ReactComponent as IndependienteActiveIcon } from "../public/svg/HandshakeActive.svg";
import { ReactComponent as IndependienteInactiveIcon } from "../public/svg/HandshakeInactive.svg";
import { ReactComponent as PensionadoActiveIcon } from "../public/svg/HandCoinsActive.svg";
import { ReactComponent as PensionadoInactiveIcon } from "../public/svg/HandCoinsInactive.svg";
import { ReactComponent as EstudianteActiveIcon } from "../public/svg/StudentActive.svg";
import { ReactComponent as EstudianteInactiveIcon } from "../public/svg/StudentInactive.svg";

import BancoAvvillas from "../public/logos/bank-avvillas.png";
import Bancolombia from "../public/logos/bank-bancolombia.png";
import Bancolombia2 from "../public/logos/bank-bancolombia2.png";
import BancoBBVA from "../public/logos/bank-bbva.png";
import BancoAgrario from "../public/logos/bank-agrario.png";
import BancoBogota from "../public/logos/bank-bogota.png";
// import BancoBancamia from "../public/logos/bank-bancamia.png";
import BancoCiti from "../public/logos/bank-citi.png";
import BancoDaviplata from "../public/logos/bank-daviplata.png";
import BancoDaviplata2 from "../public/logos/bank-daviplata2.png";
import BancoNequi from "../public/logos/bank-nequi.png";
import BancoNequiBlanco from "../public/logos/bank-nequi-blanco.png";
import BancoSantander from "../public/logos/bank-santander.png";
import BancoPopular from "../public/logos/bank-popular.png";
import BancoOccidente from "../public/logos/bank-occidente.png";
import BancoFalabella from "../public/logos/bank-falabella.png";
import BancoDavivienda from "../public/logos/bank-davivienda.png";
import BancoItau from "../public/logos/bank-itau.png";
import BancoCajaSocial from "../public/logos/bank-cajasocial.png";
// import BancoFinandina from "../public/logos/bank-finandina.png";
// import BancoGNB from "../public/logos/bank-GNB_Sudameris.png";
// import BancoMundoMujer from "../public/logos/bank-mundomujer.png";
// import BancoPichincha from "../public/logos/bank-pichincha.png";
// import BancoCredifinanciera from "../public/logos/bank-Credifinanciera.png";
// import BancoSerfinanza from "../public/logos/bank-serfinanza.png";
// import Bancoldex from "../public/logos/bank-bancoldex.png";
// import Bancoomeva from "../public/logos/bank-bancomeva.png";
// import BancoBNP from "../public/logos/bank-BNP_Paribas.png";
// import BancoColtefinanciera from "../public/logos/bank-coltefinanciera.png";
// import FinancieraJuriscoop from "../public/logos/bank-juriscoop.png";
import BancoJPMorgan from "../public/logos/bank-JP Morgan.png";
// import BancoMibanco from "../public/logos/bank-Mibanco.png";
import BancoColpatria from "../public/logos/bank-colpatria.png";
import BancoLulo from "../public/logos/bank-lulo.png";
// import BancoNu from "../public/logos/bank-nu.png";

import { ReactComponent as CorrientoActiveIcon } from "../public/svg/CurrencyCircleDollarActive.svg";
import { ReactComponent as CorrientoInacctiveIcon } from "../public/svg/CurrencyCircleDollarInactive.svg";
import { ReactComponent as AhorroInactiveIcon } from "../public/svg/PiggyBankInactive.svg";
import { ReactComponent as AhorroActiveIcon } from "../public/svg/PiggyBankActive.svg";

let isMobile = window.innerWidth <= 768;

// Event listener para actualizar isMobile cuando cambie el tamaño de la pantalla
window.addEventListener("resize", () => {
  isMobile = window.innerWidth <= 768;
});

const maritalStatusOptions = [
  {
    label: "Soltero",
    value: 1,
    icon: (
      <SolteroInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <SolteroActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Casado",
    value: 2,
    icon: (
      <CasadoInactivoIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <CasadoActivoIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Unión libre",
    value: 3,
    icon: (
      <UnionLibreInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <UnionLibreActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Divorciado",
    value: 4,
    icon: (
      <DivorciadoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <DivorciadoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
];

const genderOptions = [
  {
    label: "Masculino",
    value: 1,
    icon: (
      <HombreInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <HombreActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Femenino",
    value: 2,
    icon: (
      <FemininoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <FemininoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Otros",
    value: 3,
    icon: (
      <OtrosInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <OtrosActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
];

const educationLevelOptions = [
  {
    label: "Primaria",
    value: 1,
    icon: (
      <PrimariaInacticeIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <PrimariaActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Bachillerato",
    value: 2,
    icon: (
      <BachilleratoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <BachilleratoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Técnico",
    value: 3,
    icon: (
      <TecnicoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <TecnicoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Tecnológico",
    value: 4,
    icon: (
      <TecnologoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <TecnologoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Universitario",
    value: 5,
    icon: (
      <UniversitarioInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <UniversitarioActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Postgrado",
    value: 6,
    icon: (
      <PostgradoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <PostgradoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
];

const ocupationOptions = [
  {
    label: "Empleado",
    value: 1,
    icon: (
      <EmpleadoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <EmpleadoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Independiente",
    value: 2,
    icon: (
      <IndependienteInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <IndependienteActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Pensionado",
    value: 3,
    icon: (
      <PensionadoInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <PensionadoActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
  {
    label: "Estudiante",
    value: 4,
    icon: (
      <EstudianteInactiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
    iconSelected: (
      <EstudianteActiveIcon
        className={isMobile ? "w-16 h-16" : undefined}
        style={{
          width: !isMobile && "clamp(20px, 4vw, 60px)",
          height: !isMobile && "clamp(20px, 4vw, 60px)",
        }}
      />
    ),
  },
];

const economicActivityOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Agricultura, ganadería" },
  { value: 2, label: "Minería y canteras" },
  { value: 3, label: "Industrias manufactureras" },
  { value: 4, label: "Suministro de servicios" },
  { value: 5, label: "Construcción" },
  { value: 6, label: "Comercio al por mayor y por menor" },
  { value: 7, label: "Transporte y almacenamiento" },
  { value: 8, label: "Alojamiento y comida" },
  { value: 9, label: "Financieros y seguros" },
  { value: 10, label: "Inmobiliarias" },
  { value: 11, label: "Profesionales, cientificas y técnicas" },
  { value: 12, label: "Servicios administrativos" },
  { value: 13, label: "Educación" },
  { value: 14, label: "Salud humana y asistencia" },
  { value: 15, label: "Software y tecnología" },
  { value: 16, label: "Otro" },
];

const monthlyExpensesOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Entre $1,300,000 a $2,000,000" },
  { value: 2, label: "Entre $2,000,001 a $3,000,000" },
  { value: 3, label: "Entre $3,000,001 a $5,000,000" },
  { value: 4, label: "Más de $5,000,001" },
];

const stratumOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
];

const creditSituationOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Sin reportes negativos" },
  { value: 2, label: "Reporte negativo solo con Bancos" },
  { value: 3, label: "Reporte negativo con Bancos y otras entidades" },
  { value: 4, label: "Reporte negativo solo con Telecomunicaciones" },
  { value: 5, label: "Reporte negativo con otras entidades" },
];

const antiguedadMovilOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Menos de 3 meses" },
  { value: 2, label: "Entre 3 y 6 meses" },
  { value: 3, label: "Entre 6 y 12 meses" },
  { value: 4, label: "Más de 12 meses" },
];

const antiguedadCuentaBancariaOptions = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Menos de 3 meses" },
  { value: 2, label: "Entre 3 y 6 meses" },
  { value: 3, label: "Entre 6 y 12 meses" },
  { value: 4, label: "Más de 12 meses" },
];

const bankAccountOptions = [
  {
    value: 1,
    label: "Banco Agrario de Colombia",
    icon: <img src={BancoAgrario} className="w-8 h-8" alt="banco agrario" />,
    iconName: BancoAgrario,
  },
  {
    value: 2,
    label: "Banco AV Villas",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
    iconName: BancoAvvillas,
  },
  {
    value: 3,
    label: "Banco BBVA",
    icon: <img src={BancoBBVA} className="w-8 h-8" alt="banco bbva" />,
    iconName: BancoBBVA,
  },
  {
    value: 4,
    label: "Banco Caja Social",
    icon: (
      <img src={BancoCajaSocial} className="w-8 h-8" alt="banco caja social" />
    ),
    iconName: BancoCajaSocial,
  },
  {
    value: 5,
    label: "Banco Citibank",
    icon: <img src={BancoCiti} className="w-8 h-8" alt="banco citibank" />,
    iconName: BancoCiti,
  },
  {
    value: 6,
    label: "Banco Davivienda",
    icon: (
      <img src={BancoDavivienda} className="w-8 h-8" alt="banco davivienda" />
    ),
    iconName: BancoDavivienda,
  },
  {
    value: 7,
    label: "Banco de Bogotá",
    icon: <img src={BancoBogota} className="w-8 h-8" alt="banco agrario" />,
    iconName: BancoBogota,
  },
  {
    value: 8,
    label: "Banco de Occidente",
    icon: (
      <img src={BancoOccidente} className="w-8 h-8" alt="banco occidente" />
    ),
    iconName: BancoOccidente,
  },
  {
    value: 9,
    label: "Banco Falabella",
    icon: (
      <img src={BancoFalabella} className="w-8 h-8" alt="banco falabella" />
    ),
    iconName: BancoFalabella,
  },
  // {
  //   value: 10,
  //   label: "Banco Finandina",
  //   icon: (
  //     <img src={BancoFinandina} className="w-8 h-8" alt="banco finandina" />
  //   ),
  //   iconName: BancoFinandina,
  // },
  // {
  //   value: 11,
  //   label: "Banco GNB Sudameris",
  //   icon: <img src={BancoGNB} className="w-8 h-8" alt="banco gnb sudameris" />,
  //   iconName: BancoGNB,
  // },
  {
    value: 12,
    label: "Banco Itaú Corpbanca Colombia S.A.",
    icon: <img src={BancoItau} className="w-8 h-8" alt="banco itau" />,
    iconName: BancoItau,
  },
  // {
  //   value: 13,
  //   label: "Banco Mundo Mujer",
  //   icon: (
  //     <img src={BancoMundoMujer} className="w-8 h-8" alt="banco mundo mujer" />
  //   ),
  //   iconName: BancoMundoMujer,
  // },
  // {
  //   value: 14,
  //   label: "Banco Pichincha",
  //   icon: (
  //     <img src={BancoPichincha} className="w-8 h-8" alt="banco pichincha" />
  //   ),
  //   iconName: BancoPichincha,
  // },
  {
    value: 15,
    label: "Banco Popular",
    icon: <img src={BancoPopular} className="w-8 h-8" alt="banco popular" />,
    iconName: BancoPopular,
  },
  // {
  //   value: 16,
  //   label: "Banco Credifinanciera",
  //   icon: (
  //     <img
  //       src={BancoCredifinanciera}
  //       className="w-8 h-8"
  //       alt="banco credifinanciera"
  //     />
  //   ),
  //   iconName: BancoCredifinanciera,
  // },
  {
    value: 17,
    label: "Banco Santander de Negocios Colombia S.A.",
    icon: (
      <img src={BancoSantander} className="w-8 h-8" alt="banco santander" />
    ),
    iconName: BancoSantander,
  },
  // {
  //   value: 18,
  //   label: "Bancamia S.A",
  //   icon: <img src={BancoBancamia} className="w-8 h-8" alt="banco bancamia" />,
  //   iconName: BancoBancamia,
  // },
  // {
  //   value: 19,
  //   label: "Banco Serfinanza",
  //   icon: (
  //     <img src={BancoSerfinanza} className="w-8 h-8" alt="banco serfinanza" />
  //   ),
  //   iconName: BancoSerfinanza,
  // },
  // {
  //   value: 20,
  //   label: "Bancoldex",
  //   icon: <img src={Bancoldex} className="w-8 h-8" alt="banco bancoldex" />,
  //   iconName: Bancoldex,
  // },
  {
    value: 21,
    label: "Bancolombia",
    icon: <img src={Bancolombia} className="w-8 h-8" alt="banco bancolombia" />,
    icon2: (
      <img src={Bancolombia} className="w-8 h-8" alt="banco bancolombia" />
    ),
    iconName: Bancolombia2,
  },
  // {
  //   value: 22,
  //   label: "Bancoomeva",
  //   icon: <img src={Bancoomeva} className="w-8 h-8" alt="banco omeva" />,
  //   iconName: Bancoomeva,
  // },
  // {
  //   value: 23,
  //   label: "BNP Paribas",
  //   icon: <img src={BancoBNP} className="w-8 h-8" alt="banco BNP Paribas" />,
  //   iconName: BancoBNP,
  // },
  // {
  //   value: 24,
  //   label: "Coltefinanciera",
  //   icon: (
  //     <img
  //       src={BancoColtefinanciera}
  //       className="w-8 h-8"
  //       alt="banco coltefinanciera"
  //     />
  //   ),
  //   iconName: BancoColtefinanciera,
  // },
  // {
  //   value: 25,
  //   label: "Financiera Juriscoop",
  //   icon: (
  //     <img
  //       src={FinancieraJuriscoop}
  //       className="w-8 h-8"
  //       alt="financiera juriscoop"
  //     />
  //   ),
  //   iconName: FinancieraJuriscoop,
  // },
  {
    value: 26,
    label: "Banco JP Morgan Colombia",
    icon: <img src={BancoJPMorgan} className="w-8 h-8" alt="banco jp morgan" />,
    iconName: BancoJPMorgan,
  },
  // {
  //   value: 27,
  //   label: "Mibanco S.A",
  //   icon: <img src={BancoMibanco} className="w-8 h-8" alt="banco mibanco" />,
  //   iconName: BancoMibanco,
  // },
  {
    value: 28,
    label: "Red Multibanca Colpatria",
    icon: (
      <img src={BancoColpatria} className="w-8 h-8" alt="banco colpatria" />
    ),
    iconName: BancoColpatria,
  },
  // {
  //   value: 29,
  //   label: "Simple S.A",
  //   /* icon: <img src={BancoSimple} className="w-8 h-8" alt="banco simple" />, */
  //   iconName: "No tiene",
  // },
  {
    value: 30,
    label: "Nequi",
    icon: <img src={BancoNequi} className="w-8 h-8" alt="banco nequi" />,
    icon2: <img src={BancoNequiBlanco} className="w-8 h-8" alt="banco nequi" />,
    iconName: BancoNequi,
  },
  {
    value: 31,
    label: "Daviplata",
    icon: (
      <img src={BancoDaviplata} className="w-8 h-8" alt="banco daviplata" />
    ),
    icon2: (
      <img src={BancoDaviplata2} className="w-8 h-6" alt="banco daviplata" />
    ),
    iconName: BancoDaviplata2,
  },
  // {
  //   value: 32,
  //   label: "Nu Bank",
  //   icon: <img src={BancoNu} className="w-8 h-8" alt="banco nu" />,
  //   iconName: BancoNu,
  // },
  {
    value: 33,
    label: "Lulo Bank",
    icon: <img src={BancoLulo} className="w-8 h-8" alt="banco lulo" />,
    iconName: BancoLulo,
  },
];

const bankAccountOptionsFiltered = [
  {
    value: 1,
    label: "Banco Agrario de Colombia",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 2,
    label: "Banco AV Villas",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 3,
    label: "Banco BBVA",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 4,
    label: "Banco Caja Social",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 5,
    label: "Banco Citibank",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 6,
    label: "Banco Davivienda",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 7,
    label: "Banco de Bogotá",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 8,
    label: "Banco de Occidente",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 15,
    label: "Banco Popular",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  // {
  //   value: 18,
  //   label: "Bancamia S.A",
  //   icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  // },
  {
    value: 21,
    label: "Bancolombia",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 28,
    label: "Red Multibanca Colpatria",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 30,
    label: "Nequi",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  {
    value: 31,
    label: "Daviplata",
    icon: <img src={BancoAvvillas} className="w-8 h-8" alt="banco av villas" />,
  },
  // {
  //   value: 32,
  //   label: "Nu Bank",
  //   icon: <img src={BancoNu} className="w-8 h-8" alt="banco nu" />,
  // },
  {
    value: 33,
    label: "Lulo Bank",
    icon: <img src={BancoLulo} className="w-8 h-8" alt="banco lulo" />,
  },
];

const typeBankAccountOptionsLabel = [
  { value: "Selecciona una opción", label: "Selecciona una opción" },
  { value: "Ahorros", label: "Ahorros" },
  { value: "Corriente", label: "Corriente" },
];

const typeBankAccountOptions = [
  {
    label: "Corriente",
    value: "corriente",
    icon: <CorrientoInacctiveIcon className="w-16 h-16" fill="currentColor" />,
    iconSelected: (
      <CorrientoActiveIcon
        className="w-16 h-16 text-purple"
        fill="currentColor"
      />
    ),
  },
  {
    label: "Ahorros",
    value: "ahorros",
    icon: <AhorroInactiveIcon className="w-16 h-16" fill="currentColor" />,
    iconSelected: (
      <AhorroActiveIcon className="w-16 h-16 text-purple" fill="currentColor" />
    ),
  },
];

const hasAccountBank = [
  { value: 0, label: "Selecciona una opción" },
  { value: 1, label: "Si" },
  { value: 2, label: "No" },
];

const homologateBankNameAccount = (account, ret = "label") => {
  let banks = bankAccountOptions;
  let result;
  switch (ret) {
    case "label":
      result = banks.filter((item) => item.value === parseInt(account));
      if (result.length > 0) {
        return result[0].label;
      } else {
        return "";
      }
    case "value":
      result = banks.filter((item) => item.label === account);
      if (result.length > 0) {
        return result[0].value;
      } else {
        return "";
      }

    case "icon":
      result = banks.filter(
        (item) => item.label === account || item.value === parseInt(account),
      );
      if (result.length > 0) {
        return result[0].icon;
      } else {
        return "";
      }
    case "iconName":
      result = banks.filter(
        (item) => item.label === account || item.value === parseInt(account),
      );
      if (result.length > 0) {
        return result[0].iconName;
      } else {
        return "";
      }
    default:
      break;
  }
};

export {
  maritalStatusOptions,
  genderOptions,
  educationLevelOptions,
  ocupationOptions,
  economicActivityOptions,
  monthlyExpensesOptions,
  stratumOptions,
  bankAccountOptions,
  typeBankAccountOptions,
  creditSituationOptions,
  antiguedadMovilOptions,
  antiguedadCuentaBancariaOptions,
  hasAccountBank,
  bankAccountOptionsFiltered,
  typeBankAccountOptionsLabel,
  homologateBankNameAccount,
};
